export const getBaseEmploymentTypesKey = () => ["employmentTypes"];
export const getBaseEmploymentTypesListKey = () => [...getBaseEmploymentTypesKey(), "list"];

export const getMemberEmploymentsKey = () => ["member-employments"];
export const getBaseEmploymentsListKey = () => ["employments","list"];
export const getMemberEmploymentsPreviousKey = () => ["member-employments","previous"];
export const getMemberEmploymentsCurrentKey = () => ["member-employments","current"];
export const getMemberEmploymentsNextKey = () => ["member-employments","next"];

